// ** React Imports
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import React, { useMemo } from "react";

// ** MUI Components
import { Box, Typography, Tooltip, AvatarGroup, Avatar, IconButton } from "@mui/material";

// ** Icon Imports
import Icon from 'components/icon';

// ** Custom Component Imports
import CustomChip from "components/mui/chip";

// ** Third-Party Imports
import dayjs from "dayjs";

// ** Logic Imports
import { GetJobsiteVisits } from "./GetJobsiteVisits";

export const useJobsiteVisitLogic = (payload, setLoading) => {
  //#region Hooks
  const navigate = useNavigate();
  //#endregion Hooks
  
  //#region States
  const [jobsiteVisits, setJobsiteVisits] = useState([]);
  const [jobsiteVisitsPaginationModel, setJobVisitsPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  //#endregion States

  //#region Handlers
  const fetchJobsiteVisits = async () => {
    setLoading(true);
    try{
      const response = await GetJobsiteVisits(payload, navigate);
      if(!response.isError){
        const formattedData = response.result.map((visit, index) => ({
          ...visit,
          id: visit.visitID
        }))
        setJobsiteVisits(formattedData);
      }
    }catch(error){
      console.error('Error fetching jobsite visits:', error)
    }finally{
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchJobsiteVisits();
  }, [])
  //#endregion Handlers

  //#region Column Configuration
  const columnsJobsiteVisit = useMemo(() => [
    // {
    //   flex: 0.1,
    //   field: "jobsiteID",
    //   minWidth: 120,
    //   headerName: "Jobsite ID",
    //   renderCell: ({ row }) => {
    //     const { jobsiteID } = row;

    //     return (
    //       <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
    //         <Typography sx={{ flexGrow: 1 }}>{jobsiteID}</Typography>
    //       </Box>
    //     );
    //   },
    // },
    // {
    //   flex: 0.1,
    //   field: "entityID",
    //   minWidth: 140,
    //   headerName: "Work Order ID",
    //   renderCell: ({ row }) => {
    //     const { entityID } = row;

    //     return (
    //       <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
    //         <Typography sx={{ flexGrow: 1 }}>{entityID}</Typography>
    //       </Box>
    //     );
    //   },
    // },
    {
        flex: 0.1,
        field: "services",
        minWidth: 140,
        headerName: "Services",
        renderCell: ({ row }) => {
            const { services } = row;

            return (
            <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
                <Typography sx={{ flexGrow: 1 }}>{services || '-'}</Typography>
            </Box>
            );
        },
    },
    {
      flex: 0.1,
      field: "jobIDs",
      headerName: "Job ID",
      minWidth: 210,
      renderCell: ({ row }) => {
        const { jobIDs } = row;

        return (
          <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
            {jobIDs && jobIDs.length > 0 ? (
                <Typography variant='body1'>
                    {jobIDs.map((jobID, index) => (
                        <span key={jobID}>
                        {jobID}
                        {index < jobIDs.length - 1 && ", "}
                        </span>
                    ))}
                </Typography>
            ) : (<Typography variant='body2' color='text.secondary'>-</Typography>)}
          </Box>
        );
      },
    },
    {
      flex: 0.1,
      field: "siteCheckIn",
      headerName: "Site CheckIn",
      minWidth: 240,
      renderCell: ({ row }) => {
        const { siteCheckIn } = row;

        return (
          <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
            <Typography sx={{ flexGrow: 1 }}>{siteCheckIn ? dayjs(siteCheckIn).format('MM/DD/YYYY hh:mm A') : '-'}</Typography>
          </Box>
        );
      },
    },
    {
      flex: 0.1,
      field: "siteCheckOut",
      headerName: "Site CheckOut",
      minWidth: 240,
      renderCell: ({ row }) => {
        const { siteCheckOut } = row;

        return (
          <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
            <Typography sx={{ flexGrow: 1 }}>{siteCheckOut ? dayjs(siteCheckOut).format('MM/DD/YYYY hh:mm A') : '-'}</Typography>
          </Box>
        );
      },
    },
    {
      flex: 0.1,
      field: "visitDuration",
      headerName: "Visit Duration",
      minWidth: 160,
      renderCell: ({ row }) => {
        const { visitDuration } = row;

        return (
          <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
            <Typography sx={{ flexGrow: 1 }}>{ visitDuration ? `${visitDuration}` : '-'}</Typography>
          </Box>
        );
      },
    },
    {
      flex: 0.1,
      field: "visitStatus",
      headerName: "Visit Status",
      minWidth: 160,
      renderCell: ({ row }) => {
        const { visitStatus } = row;

        return (
          <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
            <Typography sx={{ flexGrow: 1 }}>{visitStatus}</Typography>
          </Box>
        );
      },
    },
    {
        flex: 0.1,
        field: "employeeName",
        minWidth: 140,
        headerName: "Logged By",
        renderCell: ({ row }) => {
            const { employeeName } = row;

            return (
            <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
                <Typography sx={{ flexGrow: 1 }}>{employeeName || '-'}</Typography>
            </Box>
            );
        },
    },
  ], []);
  //#endregion Column Configuration

  const JobsiteVisitProps = {
    jobsiteVisits,
    columnsJobsiteVisit,
    jobsiteVisitsPaginationModel,
    setJobVisitsPaginationModel
  };

  return {
    JobsiteVisitProps,
  };
};
